import { useCallback } from 'react'

import { useCurrentUser } from '@/features/auth'
import { useI18n } from '@/i18n'
import type { Locale } from '@/i18n'

import { useUpdatePreferences } from './usePreferences'

/**
 * 切换界面语言。
 *
 * 写两个地方：
 * - localStorage —— 没登录时也要能选，且下次首屏不闪一下别的语言
 * - 账号偏好 —— **邮件在服务器上拼**，读不到 localStorage；换了设备也该跟着走
 *
 * 没登录时只写前者。登录之后 `useCurrentUser` 那边会把账号里的语言拿回来
 * （见 features/auth 的同步），两边不一致时以账号为准。
 */
export function useLanguage() {
  const { locale, setLocale } = useI18n()
  const { user } = useCurrentUser()
  const updatePreferences = useUpdatePreferences()

  const change = useCallback(
    async (next: Locale) => {
      if (next === locale) return
      await setLocale(next)
      if (user) updatePreferences.mutate({ language: next })
    },
    [locale, setLocale, user, updatePreferences],
  )

  return { locale, change, saving: updatePreferences.isPending }
}
